export const formatDateForDisplay = (dateString: string): string => {
  if (!dateString) return "—";
  const d = new Date(dateString);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${day}/${m}/${y}`;
};

export const nextCalendarDay = (dateString: string): string => {
  if (!dateString) return "";
  const d = new Date(dateString + "T12:00:00");
  d.setDate(d.getDate() + 1);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const toDateInputValue = (dateString: string): string => {
  if (!dateString) return "";
  return new Date(dateString).toISOString().slice(0, 10);
};

export const getTodayDateInputValue = (): string => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};
